<template>
  <div>
		<v-dialog v-model="getRlImageEditDialog.show" scrollable persistent max-width="400px">
			<v-card>
				<v-card-title class="justify-center">
					<v-col md="6" class="justify-center">
						<span class="headline text-center">Edit Images</span>
					</v-col>
					<v-alert :value="getRlImageEditDialog.alert.show" dense outlined :type="getRlImageEditDialog.alert.type" :icon="getRlImageEditDialog.alert.icon">{{ getRlImageEditDialog.alert.message }}</v-alert>
					<v-alert :value="isMaxQuantitieImages" dense outlined >Max quantity added images is 10.</v-alert>
				</v-card-title>
				<v-card-text>					
          			<v-progress-linear :active="isLoading" height="3" indeterminate absolute color="primary" />					
						<v-col cols="12" v-for="(image, index) in dataBaseImages" :key="image.id" class="d-flex child-flex">
							<v-card v-if="image.delete ? false : true " flat tile class="d-flex">						
								<v-img :src="image.url" label='piesek' aspect-ratio="1" style="cursor: pointer" @click="setRlImageFullSizeDialog({show: true, imgUrl: image.url})">										
									<template v-slot:placeholder>											
										<v-row class="fill-height ma-0" align="center" justify="center">
											<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
										</v-row>
									</template>								
								</v-img>
								<v-btn class="ma-2" text icon color="grey lighten-2" @click.prevent="setDeleteDataBaseImages(index)">
									<v-icon>close</v-icon>
								</v-btn>
							</v-card>
						</v-col>		
						<v-col cols="12"  v-for="(image, index) in images.shownImages" :key="index" class="d-flex child-flex">
							<v-card v-if="image.delete ? false : true " flat tile class="d-flex">						
								<v-img :src="image.image" aspect-ratio="1" style="cursor: pointer, filter: blur(8px), -webkit-filter: blur(8px)">								
									<template v-slot:placeholder>										
										<v-row class="fill-height ma-0" align="center" justify="center">
											<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
										</v-row>
									</template>								
								</v-img>
								<v-btn class="ma-2" text icon color="grey lighten-2" @click.prevent="setDeleteAddImages(index)">
									<v-icon>close</v-icon>
								</v-btn>
							</v-card>
						</v-col>								
				</v-card-text>
				<v-card-actions>					
					<input ref="inputFile" @change="setImages" type="file" :rules="[...getRlDialogRules.required, ...getRlDialogRules.imageSize]" accept="image/png, image/jpeg" prepend-icon="add_a_photo" show-size counter multiple label="Image input" />
					<v-btn color="primary" :disabled="dialogLoading || isLoading" @click="$refs.inputFile.click()" class="ma-2" value="left" >Choose File</v-btn>				
					<v-spacer />		
					<v-btn color="primary darken-1" text @click.prevent="openCloseImageDialog" >Close</v-btn>
					<v-btn color="primary" :disabled="dialogLoading || isLoading" @click.prevent="openSaveImageDialog">Save</v-btn>					
				</v-card-actions>			
        </v-card>
		</v-dialog>
		<rl-image-full-size-dialog />
		<save-dialog />
		<close-dialog />
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import RlImageFullSizeDialog from './FullSizeDialog.vue'
import SaveDialog from './SaveDialog.vue'
import CloseDialog from './CloseDialog.vue'
import axios from 'axios'
import imageCompression from 'browser-image-compression';

export default {
	components: {
		RlImageFullSizeDialog: RlImageFullSizeDialog,
		SaveDialog: SaveDialog,
		CloseDialog: CloseDialog,
	},
	data() {
		return {
			isMaxQuantitieImages: false,
			dialogLoading: false,			
			dataBaseImages: [],			
			images: {shownImages: [], savedImages: []},			
			isLoading: false
		}
	},		
	watch: {
		'getRlImageEditDialog.show'(newValue, OldValue) {
			if (newValue) {
				this.dataBaseImages = this.setDeleteVariableInImages(this.getRlImageEditDialog.images)							
			} else {      
				this.dataBaseImages = []
			}
		},
		'getRlImageSaveDialog.save'() {				
			if (this.getRlImageSaveDialog.save === true) {
				this.saveDialog()
			}					
		},
		'getRlImageCloseDialog.close'() {
			if (this.getRlImageCloseDialog.close === true) {
				this.closeDialog()
			}
		}
 	},
	methods: {
		async compressImage(image) {    
			let compressedFile			
			const options = {
				maxSizeMB: 1,
				maxWidthOrHeight: 1000,
				useWebWorker: true
			}
			try {
				compressedFile = await imageCompression(image, options);			
			} catch (error) {

			}
			return compressedFile
		},
		checkQuantitieImages(e){
			let qua = e.target.files.length 
			qua += this.getFilterDeleteImages(this.images.savedImages,false).length			
			this.isMaxQuantitieImages = (qua > 10) && true
		},		
		readFileAsync(file) {
			return new Promise((resolve, reject) => {
				let reader = new FileReader();
					reader.onload = () => {
					resolve(reader.result);
				};
				reader.onerror = reject;
				reader.readAsDataURL(file);
			})
		},
		async setImages(e) {	

			this.checkQuantitieImages(e)

			if(!this.isMaxQuantitieImages){
				try{
					this.isLoading = true;
					let oldImages = { shownImages: Object.assign([], this.images.shownImages), savedImages: Object.assign([], this.images.savedImages) }
					let newImages = { shownImages: [], savedImages: [] }
					let input = e.target;
					let count = input.files.length;		
					let index = 0;			
					if(input.files){
						while(count --) {			
							newImages.shownImages.push( { "image": await this.readFileAsync(input.files[index]), "delete": false } )	
							let image = await this.compressImage(input.files[index])				
							image.delete = false						
							newImages.savedImages.push(image)         	
							index++;
						}			
						this.images = Object.assign({},{					
							shownImages: [...this.getFilterDeleteImages(oldImages.shownImages, false), ...newImages.shownImages],
							savedImages: [...this.getFilterDeleteImages(oldImages.savedImages, false), ...newImages.savedImages]
						})        							
						newImages = {}				
					}								
					this.clearInput()
				}catch{
					this.isLoading = false
				}
				this.isLoading = false
			}
		},
		setDeleteVariableInImages(dBImages) {
			let newDBImages = [];
			dBImages.forEach(img => {
				if(!img.delete){
					img.delete = false;
					newDBImages.push(img)
				}
			})			
			return newDBImages;
		},
		saveImage() {			
			let formData = new FormData()			
			let sortDeleteImages = this.getFilterDeleteImages(this.images.savedImages, false)
			sortDeleteImages.forEach(image => {				
				formData.append('images[]',image ,image.name)
			});
			return formData			
		},
		closeDialog() {					
			this.images = {shownImages: [], savedImages: []},		
			this.dataBaseImages = [];			
			this.clearInput();
			this.isMaxQuantitieImages = false;
			this.setRlImageEditDialog({show: false, alert: {show: false, type: null, icon: null, message: null}})
			this.setRlEntryList()
		},			
		clearInput() {
			this.$refs.inputFile.value=null;
		},
		changeDeleteStatus(images, imageIndex) {
			let newImage1 = images[imageIndex];
			newImage1['delete'] = !newImage1['delete'];			
			let newImage2 = Object.assign(newImage1);	
			this.$set(images, imageIndex, newImage2)
		},
		setDeleteAddImages(imageIndex) {				
			this.changeDeleteStatus(this.images.shownImages, imageIndex)
			this.changeDeleteStatus(this.images.savedImages, imageIndex)		
			this.isMaxQuantitieImages = false
		},	
		setDeleteDataBaseImages(imageIndex) {		
			this.changeDeleteStatus(this.dataBaseImages, imageIndex)		
		},
		getFilterDeleteImages(images, isDelete) {	
			const sortDeleteImages = images.filter(img => {
				return img.delete === isDelete;
			});	
			return sortDeleteImages				
		},
		openCloseImageDialog() {
			let quantityDeleteImage = 0;
			let quantityAddImage = 0;
		    if(this.dataBaseImages){				
				quantityDeleteImage = (this.dataBaseImages.length > 0) ?
				this.getFilterDeleteImages(this.dataBaseImages, true).length: 0	
			}	
			if(this.images.savedImages){					
				quantityAddImage = (this.images.savedImages.length > 0) ?
				this.getFilterDeleteImages(this.images.savedImages, false).length : 0		
			}						
			if (quantityDeleteImage + quantityAddImage > 0) {
				this.setRlImageCloseDialog({ show: true, close: false })			
			} else {
				this.closeDialog()
			}
		},
		openSaveImageDialog() {
			let quantityDeleteImage = 0;
			let quantityAddImage = 0;
		    if(this.dataBaseImages){								
				quantityDeleteImage = (this.dataBaseImages.length > 0) ?
				this.getFilterDeleteImages(this.dataBaseImages, true).length: 0	
			}	
			if(this.images.savedImages){					
				quantityAddImage = (this.images.savedImages.length > 0) ?
				this.getFilterDeleteImages(this.images.savedImages, false).length : 0		
			}	
		
			const item = `${quantityDeleteImage} images will be deleted, ${quantityAddImage} images will be added`
			
			if (quantityDeleteImage + quantityAddImage > 0) {
				this.setRlImageSaveDialog({ show: true, save: false, item: item })			
			} else {
				this.closeDialog()
			}
		},
		async saveDialog() {
			try {							
				if(this.dataBaseImages.length !==0) {					
					await this.deleteImagesDataBase()	
				}						
				if(this.getFilterDeleteImages(this.images.savedImages, false).length !== 0) {				
					await axios.post('/api/v1/recyclingLedgerEntries/'+this.getRlImageEditDialog.entryId+'/images', this.saveImage())							
				}	
				this.closeDialog()												
			} catch(error) {				
				this.setRlImageEditDialog({show: true, alert: {show: true, type: null, icon: null, message: error.message}})
			}			
		},	
		async deleteImagesDataBase(){
			if (this.dataBaseImages.length !== 0) {
				try {		
					let promiseArrayDelete = [];				
				    let sortDeleteImages = this.getFilterDeleteImages(this.dataBaseImages, true)					
					sortDeleteImages.forEach( img => {
						promiseArrayDelete.push(axios.delete('/api/v1/recyclingLedgerEntries/'+this.getRlImageEditDialog.entryId+'/images/'+img.id))
					})									
					await Promise.all(promiseArrayDelete);					
				} catch(error) {
					this.setRlImageEditDialog({show: true, alert: {show: true, type: null, icon: null, message: error.message}})
				}								
			}	
		},		
		...mapActions([
			'setRlImageCloseDialog',
			'setRlImageSaveDialog',
			'setRlEntryList',
			'setRlImageEditDialog',
    	'setRlImageFullSizeDialog' 
		])
	},
	computed: {
    ...mapGetters([
		'getRlImageCloseDialog',      
		'getRlImageSaveDialog',
		'getRlDialogRules',
		'getRlEntryList',
		'getRlEntry',
		'getRlImageEditDialog',
		'getRlImageFullSizeDialog'
	])
  }
}
</script>

<style scoped>
	.child-flex {
		padding: 0px;
	}
	.v-image {
		margin: 12px;
	}
	.v-img {
		cursor: pointer;
	}
	input[type="file"] {
		display: none;		
	}	
</style>



